import { getCookie, deleteCookie } from 'cookies-next';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const VisitTracker = ({ id }) => {
  const [savedOrigin, setSavedOrigin] = useState(undefined);

  useEffect(() => {
    const fwOrigin = getCookie('fwOrigin');
    if (typeof fwOrigin !== 'undefined') {
      // do stuff
      setSavedOrigin(fwOrigin);
    }
    deleteCookie('fwOrigin');

    return () => {
      setSavedOrigin(undefined);
    };
  }, []);

  if (typeof savedOrigin !== 'undefined' && id) {
    return (
      <Script
        async
        src="https://dhc-scripts.spinwise.com/umami/casinoVisit.js"
        current-domain={window.location?.hostname}
        referrer-domain={savedOrigin}
        website-id={id}
      ></Script>
    );
  }
  return <></>;
};

export default VisitTracker;
